
import env from '@beam-australia/react-env'
import { Box, Button, CircularProgress } from '@material-ui/core'
import { Auth } from 'api/index'
import { bosscatHomeServicesLogo, icons, idVerified, mailAtSign } from 'assets/index'
import { userActions } from 'ducks/actions'
import { getUserPrimaryEmail } from 'ducks/selectors'
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
type Props = {}

const auth0AppId = env('AUTH0_CLIENT_ID')

const VerifyEmail = (props: Props) => {

    const [authId, setAuthId] = useState('')
    const [isLoading, setIsLoading] = useState(true)
    const [sendVerificationEmail, setSendVerificationEmail] = useState(false)



    const userEmail = useSelector(getUserPrimaryEmail)

    const dispatch = useDispatch()

    const handleSendVerificationEmail = () => {
        dispatch(userActions.sendVerificationEmail({ userEmail: authId.split('|')[1], auth0AppId }, (success) => {
            if (success) {
                setSendVerificationEmail(true)
            } else {
                toast.error("Failed to send verification email")
            }
        }))
    }

    useEffect(() => {
        setIsLoading(true)
        dispatch(userActions.getUserInfo(null, (succ, userInfo) => {
            if (succ && userInfo) {
                console.log('userInfo', userInfo)
                setAuthId(userInfo.sub)
                setIsLoading(false)
            }
        }))
    }, [])

    return (
        <Box width={"100%"} display="flex" flexDirection="column" alignItems={"center"} gridGap="16px" paddingTop={"40px"}>
            {sendVerificationEmail ? <>
                <img src={bosscatHomeServicesLogo} style={{ width: "280px", height: "66px", marginBottom: "96px" }} alt="bosscatHomeServicesLogo" />
                <img src={mailAtSign} alt="mailAtSign" />
                <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0" }}>CHECK YOUR INBOX</p>
                <p style={{ fontSize: "16px", fontWeight: "normal", margin: "0" }}>{`We sent the verification link to your email: ${userEmail}`}</p>
            </> : <>
                <img src={bosscatHomeServicesLogo} style={{ width: "280px", height: "66px", marginBottom: "96px" }} alt="bosscatHomeServicesLogo" />
                <img src={idVerified} alt="idVerified" />
                <p style={{ fontSize: "20px", fontWeight: "bold", margin: "0" }}>VERIFY YOUR ACCOUNT</p>
                <p style={{ fontSize: "16px", fontWeight: "normal", margin: "0" }}>As a last step, we need you to verify your account.</p>
                <p style={{ fontSize: "16px", fontWeight: "normal", margin: "0", maxWidth: "450px", textAlign: "center" }}>You can request a new email with the instructions to verify your account by clicking on the following button.</p>
                <Button onClick={handleSendVerificationEmail} variant="contained" color="primary" disabled={isLoading} startIcon={<icons.Email style={{ color: "white", textTransform: "none" }} />}>{'Request New Verification'}</Button>
            </>}
        </Box>
    )
}

export default VerifyEmail